import { exercisesList } from "@components/ExerciseListingPage/ExercisesList"
import { Autocomplete, TextField } from "@mui/material"
import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router"
import styles from "./ReportPageContentHeader.module.css"
import { exerciseTypeIconMapping } from "src/utils/exerciseTypeIconMapping"

export const ReportPageContentHeader = ({ profileDetails }) => {
    const [selectedExercise, setSelectedExercise] = useState(null)
    const { gameDetails } = useParams()
    const [game, path] = gameDetails.split("@")
    let exerciseType = "vr"
    if (path === "nonVR") {
        exerciseType = exercisesList[path].find(
            (item) => item.code === selectedExercise?.id
        )?.type
    }

    const navigate = useNavigate()

    const handleExerciseChange = (e, newValue) => {
        setSelectedExercise(newValue)
    }

    const getExerciseOptions = () => {
        if (!profileDetails) return []

        const exerciseNames = Object.keys(profileDetails.exercises[path])
            .filter(
                (item) =>
                    profileDetails.exercises[path][item]?.scoreHistory?.length >
                    0
            )
            .map((code) => {
                const exercise = exercisesList[path].find(
                    (exercise) => exercise.code === code
                )
                return { label: exercise.name, id: exercise.code }
            })
        return exerciseNames
    }

    useEffect(() => {
        if (selectedExercise) {
            navigate(`/report/${selectedExercise.id}@${path}`)
        }
    }, [selectedExercise, path, navigate])

    useEffect(() => {
        const foundItem = getExerciseOptions()?.find(
            (item) => item?.id === game
        )
        if (foundItem) {
            setSelectedExercise(foundItem)
        } else {
            setSelectedExercise(null)
        }
    }, [profileDetails, game])

    return (
        <div className="flex items-center justify-between bg-[var(--bg-theme-lightest)] flex-shrink-0 h-20 rounded-2xl px-4 py-7">
            <div className="flex items-center gap-2">
                <img
                    src={exerciseTypeIconMapping?.[exerciseType]}
                    alt={`type exercise`}
                    className="flex items-center justify-center h-6 w-12 object-contain"
                />
                <span className="uppercase">{`${game} Report `}</span>
            </div>
            <Autocomplete
                className={`w-[200px]  ${styles.Autocomplete}`}
                options={getExerciseOptions()}
                sx={{
                    "& .MuiOutlinedInput-root": {
                        border: "1px solid var(--border-blue)",
                        background: "var(--pure-white)",
                        borderRadius: "8px",
                        "& fieldset": {
                            border: "none",
                        },
                        padding: ".3rem .5rem",
                    },
                    "& .MuiAutocomplete-root": {
                        borderRadius: "16px !important",
                    },
                }}
                renderInput={(params) => <TextField {...params} />}
                onChange={handleExerciseChange}
                value={selectedExercise}
                clearIcon={false}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                getOptionKey={(option) => option.id}
            />
        </div>
    )
}
